import { Component, OnInit, Input } from '@angular/core';
import { IDocumentRevHistoryModel, IDocRevHistoryOutputModel } from 'src/app/ViewModel/DocumentModel';
import { DocumentService } from 'src/app/Service/document/document.service';

@Component({
  selector: 'app-document-revision-history',
  templateUrl: './document-revision-history.component.html',
  styleUrls: ['./document-revision-history.component.css']
})
export class DocumentRevisionHistoryComponent implements OnInit {
  @Input() inputModel!: IDocumentRevHistoryModel;
  revisionHistoryList: IDocRevHistoryOutputModel[] = [];

  constructor(
    private _docService: DocumentService,
  ) { }

  ngOnInit() {
    if (this.inputModel != null) {
      this.bindGrid();
    }
  }

  public async bindGrid() {
    this.revisionHistoryList = await this._docService.getDocumentRevisionHistory(this.inputModel).toPromise();
  }
}
